import { books } from './data/books';
import { Bookshelf } from './Bookshelf';

/* Both /bookshelf/ and /bookshelf/<slug>/ resolve to this one file, and that
   is the point of the catch-all rather than a pair of routes.
 *
 * Next swaps the page component whenever the URL maps to a different page
 * FILE, shallow or not. With an index route and a [slug] route, clicking a
 * book tore the WebGL scene down and rebuilt it in the middle of the flight:
 * the book flew, the canvas was destroyed, and the new mount flew it again
 * from the pile. One file, one component, so the push is a genuine shallow
 * change and the scene survives it.
 */
export default function BookshelfPage({ slug }) {
  return <Bookshelf initialSlug={slug} />;
}

export const getStaticProps = async ({ params }) => {
  const slug = params?.slug?.[0] ?? null;
  if (slug && !books.some(book => book.slug === slug)) return { notFound: true };
  return { props: { slug } };
};

export const getStaticPaths = async () => ({
  paths: [
    { params: { slug: [] } },
    ...books.map(book => ({ params: { slug: [book.slug] } })),
  ],
  fallback: false,
});
